export default __webpack_public_path__ + "static/media/cross-icon.b60b9a25.svg";